import {Injectable} from '@angular/core';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminDocumentsService {
  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(private http: HttpClient) {}

  /**
   *  Met à jour le statut d'un document
   *  Renvoi : 404 si pas de document trouvé ou status: success
   * @param document
   * @param bookingId
   */
  changeDocumentStatus(document,bookingId) {
    return this.http.post(`${this.apiUrl}documents/setState`, {document,bookingId});
  }

  replaceFile(bookingId, newDocId) {
    return this.http.post(`${this.apiUrl}user/fileReplace/`, {bookingId,newDocId});
  }
  generateCaution(userId, bookingId) {
    return this.http.post(`${this.apiUrl}user/regenerateDoc/`, {userId,bookingId});
  }
}
